import type { IFaqCategory } from './faq-types';

export const faqWatch: IFaqCategory = {
  title: 'Apple Watch',
  slug: 'apple-watch',
  items: [
    {
      question: 'How do I start reviewing on my watch?',
      answer:
        'Open Cool Mate on your Apple Watch. Make sure you are signed in on your iPhone first. The session syncs automatically.',
    },
    {
      question: 'Why is my watch not syncing?',
      answer:
        'Make sure your iPhone and Apple Watch are nearby and connected. Try tapping Last Synced to force a sync. If the issue persists, restart both devices.',
    },
    {
      question: 'Does the watch app work offline?',
      answer:
        'The watch app needs a connection to your iPhone to sync your session and submit reviews.',
    },
    {
      question: 'Which Apple Watch models are supported?',
      answer: 'Cool Mate supports Apple Watch Series 4 and later running watchOS 9 or newer.',
    },
  ],
};
